import ApplicationController from './application_controller.js'
export default class DropDownMenuController extends ApplicationController {

  static targets = ["menu"]

  connect() {
    this.attach_listener()
  }

  disconnect() {
    this.remove_listener()
  }

  attach_listener() {
    this.evtL1 = this.evtMouseEnter.bind(this)
    this.element.addEventListener('mouseenter', this.evtL1, false)
    this.evtL2 = this.evtMouseLeave.bind(this)
    this.element.addEventListener('mouseleave', this.evtL2, false)
  }

  remove_listener() {
    this.element.removeEventListener('mouseenter', this.evtL1, false)
    this.element.removeEventListener('mouseleave', this.evtL2, false)
  }

  evtMouseEnter() {
    var style = this.menuTarget.style
    style.display = "block"
    style.zIndex = 1000
    style.position = "absolute"
    style.left = "-210px"
  }

  evtMouseLeave() {
    this.menuTarget.style.display = "none"
  }

}